
export function toast (vm, type, message) {
  vm.$buefy.toast.open({
    message,
    type,
    position: 'is-top-right'
  })
}

export function toastSuccess (vm, message) {
  toast(vm, 'is-success', message)
}

export function toastDanger (vm, message) {
  toast(vm, 'is-danger', message)
}

export async function attemptActionWithToast (vm, promiseFunc, isLoadingChangesFunc, successMessage, errorMessageFunc) {
  try {
    isLoadingChangesFunc(true)
    const res = await promiseFunc()
    if (successMessage !== null) {
      toastSuccess(vm, successMessage)
    }
    return res
  } catch(e) {
    toastDanger(vm, errorMessageFunc(e))
    return null
  } finally {
    isLoadingChangesFunc(false)
  }
}

export async function confirm (vm, message) {
  return new Promise(resolve => {
    vm.$buefy.dialog.confirm({
      message: message,
      type: 'is-danger',
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false)
    })
  })
}

export async function askQuestion (vm, message, placeholder, type) {
  return new Promise((resolve) =>
    vm.$buefy.dialog.prompt({
      type,
      message,
      inputAttrs: { placeholder },
      trapFocus: true,
      onConfirm: (value) => resolve(value),
      onCancel: () => resolve(null)
    }))
}